import * as React from 'react';
import clsx from 'clsx';
import themePrimary from '../../styles/themePrimary';
import { makeStyles, StepIconProps, useMediaQuery } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import LoaderImage from '../../images/loader.png';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import LogoImage from '../../images/logo_footer.png'
import { ElementDimensions } from '../../styles/ElementDimensions';

const useStyles = makeStyles({
    root: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        height: '100%',
        textAlign: 'center',
    },
    '@keyframes check1': {
        '0%': {
            transform: 'rotateZ(45deg)',
        },
        '50%': {
            left: 'calc((100vw - 36px) / 2)',
            top: '290px',
            transform: 'rotateZ(45deg)',
        },
        '100%': {
            left: 'calc((100vw - 36px) / 2)',
            top: '290px',
            transform: 'rotateZ(45deg)',
        },
    },
    '@keyframes check2': {
        '0%': {
            transform: 'rotateZ(45deg)',
        },
        '50%': {
            left: 'calc((100vw - 26px) / 2)',
            top: '155px',
            transform: 'rotateZ(45deg)',
        },
        '100%': {
            left: 'calc((100vw + 106px) / 2)',
            top: '100px',
            transform: 'rotateZ(45deg)',
        },
    },
    '@keyframes translate': {
        '0%': {
            transform: 'translate(0px)',
        },
        '100%': {
            transform: 'translate(144px)',
        },
    },
    customLogo: {
        position: 'absolute',
        left: 'calc((100vw - 144px) / 2)',
        top: '200px',
        width: '144px',
        height: '81px',
    },
    customLogoOverlay: {
        position: 'absolute',
        left: 'calc((100vw - 144px) / 2)',
        top: '200px',
        width: '144px',
        height: '81px',
        backgroundColor: '#ffffffaa',
        animation: '$translate 3s linear infinite',
    },
    customLogoLandscapePaymentScreen: {
        position: 'absolute',
        left: 'calc(100vw *.3)',
        top: '70px',
        width: '144px',
        height: '81px',
    },
    customLogoOverlayLandscapePaymentScreen: {
        position: 'absolute',
        left: 'calc(100vw *.3)',
        top: '70px',
        width: '144px',
        height: '81px',
        backgroundColor: '#ffffffaa',
        animation: '$translate 3s linear infinite',
    },
    customLogoLandscapeFullScreen: {
        position: 'absolute',
        left: 'calc((100vw / 2) - 82px)',
        top: '70px',
        width: '144px',
        height: '81px',
    },
    customLogoOverlayLandscapeFullScreen: {
        position: 'absolute',
        left: 'calc((100vw / 2) - 82px)',
        top: '70px',
        width: '144px',
        height: '81px',
        backgroundColor: '#ffffffaa',
        animation: '$translate 3s linear infinite',
    },
    logoContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        textAlign: 'center',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    logoContainerLandscape: {
        position: 'absolute',
        bottom: 0,
        left: 'calc(100vw * .3)',
        right: 0,
        width: '100%',
        textAlign: 'center',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    logo: {
        position: 'absolute',
	    left: 'calc((100vw - 47px) / 2)',
	    top: '200px',
	    width: '95px',
	    height: '74px',
    },
    logoImageLandscape: {
        position: 'absolute',
        bottom: '20px',
        left: 'calc((100vw * .3) - 28px)',
    },
    logoLandscape: {
        position: 'absolute',
	    left: 'calc((100vw * .3) + ((100vw - 100vw *.3)) / 2 - 47px)',
	    top: '100px',
	    width: '95px',
	    height: '74px',
    },
    logoOverlay1: {
        position: 'absolute',
	    left: 'calc((100vw - 126px) / 2)',
	    top: '245px',
	    width: '100px',
        height: '100px',
        backgroundColor: '#ffffff',
        animation: '$check1 2s linear infinite alternate',
    },
    logoOverlay2: {
        position: 'absolute',
	    left: 'calc((100vw - 26px) / 2)',
	    top: '155px',
	    width: '100px',
        height: '100px',
        backgroundColor: '#ffffff',
        animation: '$check2 2s linear infinite alternate',
    },
});

export interface LoaderLandscapePaymentProps {
    isFullScreen: boolean;
}

export default function LoaderLandscapePayment(props: LoaderLandscapePaymentProps) {
    const { isFullScreen } = props;
    const isPortrait = useMediaQuery('(orientation: portrait)');
    const [logoUrl, setLogoUrl] = React.useState<string>('');
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });
    
    React.useEffect(() => {
        if (checkOutState.state.skin.use_custom_skin) {
            setLogoUrl(checkOutState.state.restaurantLoaderUrl === null ? '' : checkOutState.state.restaurantLoaderUrl);
        }
        
    }, [checkOutState.state.restaurantLogoUrl, checkOutState.state.skin.use_custom_skin]);

    return (
        <div className={classes.root}>
        {checkOutState.state.skin.use_custom_skin && logoUrl !== '' &&
            <div>
                <img className={clsx({
                    [classes.customLogoLandscapeFullScreen]: isFullScreen,
                    [classes.customLogoLandscapePaymentScreen]: !isFullScreen,
                })} src={logoUrl} />
                <div 
                    className={clsx({
                        [classes.customLogoOverlayLandscapeFullScreen]: isFullScreen,
                        [classes.customLogoOverlayLandscapePaymentScreen]: !isFullScreen,
                    })}>
                </div>
            </div>
        }

        {!checkOutState.state.skin.use_custom_skin &&
            <div>
                <img className={clsx({
                    [classes.logo]: isPortrait,
                    [classes.logoLandscape]: !isPortrait,
                })} src={LoaderImage} />

                {isPortrait &&
                    <div className={classes.logoOverlay1}></div>
                }
                
                {isPortrait &&
                    <div className={classes.logoOverlay2}></div>
                }
            </div>
        }

        {(!checkOutState.state.skin.use_custom_skin || (checkOutState.state.skin.use_custom_skin && isPortrait)) &&
            <div className={clsx({
                [classes.logoContainer]: isPortrait,
                [classes.logoContainerLandscape]: !isPortrait,
            })}>
                <img src={LogoImage} className={clsx({
                    [classes.logoImageLandscape]: !isPortrait,
                })}></img>
            </div>
        }
        
      </div>
    );
};